import { logger } from '@/utils/logger';
/**
 * Environment detection and configuration utilities
 */

export const isDevelopment = () => import.meta.env.DEV;
export const isProduction = () => import.meta.env.PROD;

/**
 * Safe console logging that only logs in development
 */
export const devLog = (...args: any[]) => {
  if (isDevelopment()) {
    logger.debug(...args);
  }
};

export const devError = (...args: any[]) => {
  if (isDevelopment()) {
    logger.error(...args);
  }
};

export const devWarn = (...args: any[]) => {
  if (isDevelopment()) {
    logger.warn(...args);
  }
};

/**
 * Get environment-specific configuration
 */
export const getConfig = () => {
  const config = {
    supabase: {
      url: import.meta.env.VITE_SUPABASE_URL || "https://smoeiokykejsjaxkzivt.supabase.co",
      anonKey: import.meta.env.VITE_SUPABASE_ANON_KEY || "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InNtb2Vpb2t5a2Vqc2pheGt6aXZ0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDg5MTc0NjcsImV4cCI6MjA2NDQ5MzQ2N30.StoYYMVzUeC5HDPjfQh5LrFuKBFY4Xoyn5nmPz3SMJI"
    },
    api: {
      retryAttempts: isProduction() ? 3 : 1,
      timeout: isProduction() ? 10000 : 5000
    }
  };
  
  return config;
};